export const uiConstants = {
  PUSH_NOTIFICATION: '[Ui] Push notification',
  REMOVE_NOTIFICATION: '[Ui] Remove notification'
}
